import type State from '@contactcentre-web/redux-common/types/State';

export const getLocale = (state: State) => state.profile.locale;
